import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

import { redirect_URL, saw_URL } from '../../config';


import { useSelector } from 'react-redux';
import { RootState } from 'store/reducers';
import { localStorageKeyValue, setLocalStorageValue } from 'utils/handler';
import RegistrarVariant1 from './RegistrarVariant1';
import RegistrarVariant2 from './RegistrarVariant2';

export const Info: React.FC = (): JSX.Element => {
  let { search } = useLocation();
  const [domainName, setDomainName] = useState('');
  const [registrarId, setRegistrarId] = useState('');
  const [variant, setVariant] = useState('1');
  const { registrarDetails } = useSelector((state: RootState) => state.userReducer);
  const { searchedDomain } = useSelector((state: RootState) => state.mainReducer);
  // let windowDetail: Window | null = null
  useEffect(() => {
    const query = new URLSearchParams(search);
    const dn: string = query.get('domainName') || '';
    const rId: string = query.get('registrarId') || '';
    const varnt: string = query.get('temp') || '';
    setDomainName(dn);
    setRegistrarId(rId);
    setVariant(varnt)
  }, [search]);

  const learnMore = () => {
    if (registrarId) {
      setLocalStorageValue(localStorageKeyValue.registrarUID, registrarId);
      // updateClicks(registrarId, domainName)
    }
    if(variant === "1") {
      // window.open(redirect_URL + '/registrar-landing-page');
      window.open(redirect_URL + '/');
    } else {
      // window.open(redirect_URL + '/registrar-landing-page');
      // window.open(saw_URL + '/buy' + (registrarDetails?.name ? `?utm_source=${registrarDetails.name}` : ""));
      window.open(redirect_URL + '/');
    }
    
    if (searchedDomain) {
      setLocalStorageValue(localStorageKeyValue.domainName, searchedDomain);
    }
    if (registrarId) {
      setLocalStorageValue(localStorageKeyValue.registrarUID, registrarId);
      // updateClicks(registrarId, domainName)
    }
  };
  // console.log('registrarDetails', registrarDetails)
  return (
    <div className="iframe-view pt-0">
      <Helmet>
        <title>Saw.com Domain Broker Service For Your Business</title>
      </Helmet>
      <div className="container">
        {
          variant === "1" ? <RegistrarVariant1 registrarDetails={registrarDetails} domainName={domainName} learnMore={learnMore} /> : <RegistrarVariant2 registrarDetails={registrarDetails} domainName={domainName} learnMore={learnMore} />
        }

      </div>
    </div>
  );
};

export default Info;
